import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import * as moment from 'moment';
import { UnitConverter } from '../../utilities/unit-converter/UnitConverter';
import { AuthService } from '../../services/auth-service/auth.service';
import { CONSTANTS } from '../../utilities/Constants';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { MatDialog } from '@angular/material';
declare var $: any;
@Component({
  selector: 'app-driver-earnings',
  templateUrl: './driver-earnings.component.html',
  styleUrls: ['./driver-earnings.component.css']
})
export class DriverEarningsComponent implements OnInit, AfterViewInit {

  drivers = [];
  companyid = null;
  summary = null;
  formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  formattedRevenueNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  @Input() start: moment.Moment;
  @Input() end: moment.Moment;
  /** Optional resolver from overview map — per-driver hex colors. */
  @Input() driverColorResolver: { getPayrollDriverMapColor(driver: any): string | null } | null = null;
  @Output() driversLoaded = new EventEmitter<any[]>();
  converter = new UnitConverter();
  constructor(private main: MainService, private auth: AuthService, private dialog: MatDialog) {
    if (!this.auth.hasOneOfRoles([CONSTANTS.ADMIN_TYPE_PROVIDER, CONSTANTS.ADMIN_TYPE_SUPER, CONSTANTS.ROLE_TYPE_DISPATCHER])) {
      this.companyid = this.auth.getClientCompanyId();
    }
  }

  ngAfterViewInit(): void {

  }

  isBearer(){
    var payload = this.auth.getAdminPayload();
    if(payload.type == 'BEARER'){
      return true;
    }
    return false;
  }

  refresh() {
    this.loadPayroll();
  }

  getJobTypeText(){
    return this.main.getJobTypeText();
  }


  driverEarningsVisible() {
    return this.auth.hasOneOfRoles([
      CONSTANTS.ADMIN_TYPE_SUPER,
      CONSTANTS.ADMIN_TYPE_PROVIDER
    ]);
  }

  hideCost(){
    return this.auth.hasOneOfRoles([
      CONSTANTS.ROLE_TYPE_DISPATCHER
    ]);
  }

  loadPayroll(start: moment.Moment = null, end: moment.Moment = null): Promise<any> {
    if (start) {
      this.start = start;
    }
    if (end) {
      this.end = end;
    }
    return this.main.driverPayroll(this.start.format('YYYY-MM-DD hh:mm A'), this.end.format('YYYY-MM-DD hh:mm A'), null, this.companyid).then((res) => {
      this.drivers = res.data.records;
      this.summary = res.data.summary;
      this.driversLoaded.emit(this.drivers);
      return res;
    }).catch(e => {
      console.log(e);
      throw e;
    })
  }

  ngOnInit() {

  }


  formatDistance(d: Number) {
    if (d) {
      return `${d.toFixed(2)}`;
    } else {
      return "0 km";
    }
  }

  formatRating(rating: number) {
    if (rating && rating > 0) {
      return rating.toFixed(1);
    } else {
      return '-';
    }
  }

  formatNewCustomers(count: number) {
    if (count && count > 0) {
      return count;
    } else {
      return 0;
    }
  }

  openNewCustomers() {
    if (!this.start || !this.end) {
      return;
    }
    new QuickDialog(this.dialog).newCustomersDialog(this.start, this.end);
  }

  getDriverRating(driver: any) {
    if (!driver || !driver.rating) {
      return "...";
    }
    
    const ratingObj = driver.rating;
    const rating = ratingObj.rating || 0;
    const driverRating = ratingObj.driver || 0;
    const recommend = ratingObj.recommend || 0;
    
    const average = (rating + driverRating + recommend) / 3;
    return Math.round(average * 10) / 10; // Round to 1 decimal place
  }

  getDriverInitials(driver: any): string {
    const name = String((driver && driver.name) || '').trim();
    if (!name) {
      return '?';
    }
    const parts = name.split(/\s+/).filter(Boolean);
    const first = parts[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1] : '';
    const f = first ? first[0].toUpperCase() : '';
    const l = last && last !== first ? last[0].toUpperCase() : '';
    return (f + l) || first.substring(0, 2).toUpperCase() || '?';
  }

  getDriverInitialsBg(color: string): string {
    if (!color || color.length < 4) {
      return color;
    }
    try {
      const hex = color.replace('#', '');
      const full = hex.length === 3
        ? hex.split('').map(c => c + c).join('')
        : hex;
      const r = parseInt(full.substring(0, 2), 16);
      const g = parseInt(full.substring(2, 4), 16);
      const b = parseInt(full.substring(4, 6), 16);
      const tr = Math.round(r + (255 - r) * 0.82);
      const tg = Math.round(g + (255 - g) * 0.82);
      const tb = Math.round(b + (255 - b) * 0.82);
      return `#${tr.toString(16).padStart(2, '0')}${tg.toString(16).padStart(2, '0')}${tb.toString(16).padStart(2, '0')}`;
    } catch (_) {
      return color;
    }
  }

  getDriverMapColor(driver: any): string | null {
    if (!this.driverColorResolver) {
      return null;
    }
    return this.driverColorResolver.getPayrollDriverMapColor(driver);
  }

  viewDriverRating(driver: any) {
    if (!driver || !driver.rating) {
      return;
    }

    // Create a mock trip object with the rating data for the dialog
    const mockTrip = {
      id: driver.id || 'driver-' + Math.random(),
      rating: driver.rating
    };

    // Use the DeliveryRatingDialog method with read-only mode, hide comment, and show numbers
    new QuickDialog(this.dialog).DeliveryRatingDialog(mockTrip, true, true, true).then(() => {
      // Dialog closed
    }).catch(e => {
      console.error('Error opening rating dialog:', e);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/driver-earnings/driver-earnings.component.ts